@if (element) {
  <mat-card
    matTooltipTouchGestures="off"
    matTooltip="You don't have access to this workspace!"
    class="workspace-card"
    [matTooltipDisabled]="!disabled"
    [class]="{ disabled: disabled }">
    <div class="card-holder">
      <div class="header-section">
        <h2 [title]="element.name" class="project-name">{{ element.name }}</h2>
        <mat-chip-listbox>
          <mat-chip highlighted [class]="element | workspaceStatusClass">
            {{ element | workspaceStatus }}
          </mat-chip>
        </mat-chip-listbox>
      </div>

      <div class="content-section">
        <span class="project-icon">{{ element.name[0] }}</span>
        <p class="description">{{ element.description }}</p>
      </div>

      <div class="footer-section">
        <div class="info-item">
          <mat-icon>group</mat-icon>
          <span>{{ element.members.length }}</span>
        </div>
        <div class="info-item">
          <mat-icon>calendar_today</mat-icon>
          <time [dateTime]="element.last_activity">{{ element.last_activity | timeAgo }}</time>
        </div>
      </div>
      <a [routerLink]="element.id" mat-button color="primary" class="open-workspace-button">Open Workspace</a>
    </div>
  </mat-card>
}
